export default "__VITE_ASSET__52eecc49__"